import {Typography} from 'components/Typography';
import React, {FC, useCallback} from 'react';
import style from './style.module.scss';
import {useInView} from 'react-intersection-observer';
import {Modal} from 'modules/modals/components/Modal';
import {MODALS} from 'modules/modals/constants';
import {useAppDispatch} from 'core/redux/hooks/useAppDispatch';
import {showModal} from 'modules/modals/thunks';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {formatPrice} from 'core/helpers';
import dynamic from 'next/dynamic';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import {useYandexSplitWidgetGtag} from 'modules/product-card/analytics/gtag/hooks/useYandexSplitWidgetGtag';

const YaSplitWidgetModal = dynamic(() => import('modules/modals/components/YaSplitWidgetModal'), {
    loading: () => <ModalLazyLoader />,
});

interface IProps {
    yandexSplitInformer: IProduct['yandexSplitInformer'];
}

const YandexSplitWidget: FC<IProps> = ({yandexSplitInformer}) => {
    const dispatch = useAppDispatch();

    const {
        handleWidgetInView,
        handleWidgetClick: handleWidgetClickGtag,
        handleModalShow: handleModalShowGtag,
        handleModalClose,
    } = useYandexSplitWidgetGtag({
        yandexSplitInformer,
    });

    const {ref} = useInView({
        triggerOnce: true,
        onChange: (inView) => {
            handleWidgetInView(inView);
        },
    });

    const handleWidgetClick = useCallback(() => {
        handleWidgetClickGtag();
        handleModalShowGtag();
        dispatch(showModal(MODALS.PRODUCT_YASPLIT_MODAL.name));
    }, [dispatch, handleModalShowGtag, handleWidgetClickGtag]);

    if (!yandexSplitInformer?.partPrice && !yandexSplitInformer?.parts) {
        return null;
    }

    return (
        <>
            <div ref={ref} className={style.container} onClick={handleWidgetClick} id={'ya-split-widget'}>
                <div className={style.row}>
                    <img src={'/images/product-detailed/split.webp'} alt={'icon'} className={style.icon} />
                    <Typography className={style.price} variant={'label-16-m'}>
                        {formatPrice(yandexSplitInformer?.partPrice, {style: 'currency'})} ×{' '}
                        {yandexSplitInformer?.parts}
                    </Typography>
                    <Typography variant={'label-12-r'} color={'gray60'} className={style.sub}>
                        без переплат
                    </Typography>
                </div>
                <Typography variant={'label-12-r'}>Яндекс Сплит можно оформить в винотеке</Typography>
            </div>
            <Modal
                name={MODALS.PRODUCT_YASPLIT_MODAL.name}
                hasPortal={true}
                willMount={true}
                onClose={handleModalClose}
            >
                <YaSplitWidgetModal yandexSplitInformer={yandexSplitInformer} />
            </Modal>
        </>
    );
};

export default YandexSplitWidget;
